import * as React from 'react';
import { DefaultButton, PrimaryButton } from '@fluentui/react';
import { TextField } from '@fluentui/react';
import { Panel } from '@fluentui/react';
import {useContext, useEffect, useState} from "react";
import {Stack} from "@fluentui/react";
import AuthContext from "../../Services/AuthContext";
import {Dropdown, Toggle} from "@fluentui/react";

function EditPerson(props) {
    const [user] = useContext(AuthContext);
    const [name, setName] = useState(props.edit.name || '');
    const [surname, setSurname] = useState(props.edit.surname || '');
    const [phone, setPhone] = useState(props.edit.phone || '');
    const [email, setEmail] = useState(props.edit.email || '');
    const [personalId, setPersonalId] = useState('');
    const [address, setAddress] = useState('');
    const [parents, setParents] = useState('');
    const [marketing, setMarketing] = useState(props.edit.marketing || false);
    const [source, setSource] = useState(props.edit.source || '');
    const [sourceList, setSourceList] = useState([]);
    const [accountManager, setAccountManager] = useState(props.edit.account_manager_id || null);
    const [sales, setSales] = useState([]);

    const _submit = (e) => {
        e.preventDefault();
        const data = {
            name: name,
            surname: surname,
            id: props.edit.id,
            marketing: marketing,
            source: source.key,
            account_manager_id: accountManager.key,
            phone: phone,
            email: email,
            personal_id: personalId,
            address: address,
            parents: parents
        };
        fetch(`/api/person/${props.edit.id}`, {
            method: 'PUT',
            body: JSON.stringify(data),
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => { props.onSuccess(json); props.dismissPanel(); })
            .catch(err => { console.log(err) })
    }

    const footer = React.useCallback(() => (<Stack horizontal horizontalAlign='space-between'>
        <PrimaryButton type='submit' form='EditPerson'>Edytuj</PrimaryButton>
        <DefaultButton onClick={props.dismissPanel}>Anuluj</DefaultButton>
    </Stack>), [props.dismissPanel]);


    useEffect(() => {
        const abortController = new AbortController();
        if (props.edit) {
            setName(props.edit.name || '');
            setSurname(props.edit.surname || '');
            setPhone(props.edit.phone || '');
            setEmail(props.edit.email || '');
            setParents(props.edit.parents || '');
            setAddress(props.edit.address || '');
            setPersonalId(props.edit.personal_id || '');
            setSource({key: props.edit.source || ''});
            setAccountManager({key: props.edit.account_manager_id || ''});
            setMarketing(props.edit.marketing || false);
            async function fetchSales() {
                await fetch(`/api/user/sales`, {
                    method: 'GET',
                    signal: abortController.signal,
                    headers: {
                        'Authorization': 'Bearer ' + user.token
                    }
                }).then(res => res.json())
                    .then(data => { setSales(data.map((item) => {return {key: item.id, text: `${item.name} ${item.surname}`};})) })
                    .catch(err => { console.log(err) })
            }
            fetchSales();
            async function fetchSources() {
                await fetch(`/api/acquisition`, {
                    method: 'GET',
                    signal: abortController.signal,
                    headers: {
                        'Authorization': 'Bearer ' + user.token
                    }
                }).then(res => res.json())
                    .then(data => { setSourceList(data.map((item) => {return {key: item, text: item};})) })
                    .catch(err => { console.log(err) })
            }
            fetchSources();
        }
        return () => abortController.abort();
    }, [props.edit, user.token])

    var optionalProps = {};
    if (marketing) optionalProps.defaultChecked = true;

    return (
        <Panel
            isOpen={props.edit}
            onDismiss={props.dismissPanel}
            headerText="Edytuj Osobę"
            closeButtonAriaLabel="Close"
            onRenderFooterContent={footer}
            isFooterAtBottom={true}
        >
            <p>{props.edit.keystring}</p>
            <form onSubmit={_submit} id='EditPerson'>
                <TextField required autoFocus label='Imię' value={name} onChange={(e) => setName(e.target.value || '')}/>
                <TextField required label='Nazwisko' value={surname} onChange={(e) => setSurname(e.target.value || '')}/>
                <Dropdown
                    label="Miejsce Pozyskania"
                    selectedKey={source ? source.key : undefined}
                    onChange={(e, item) => setSource(item)}
                    placeholder="Wybierz z listy"
                    options={sourceList}
                />
                <Dropdown
                    label="Opiekun"
                    selectedKey={accountManager ? accountManager.key : undefined}
                    onChange={(e, item) => setAccountManager(item)}
                    placeholder="Wybierz z listy"
                    options={sales}
                />
                <TextField label='Telefon' value={phone} onChange={(e) => setPhone(e.target.value || '')}/>
                <TextField label='Email' value={email} onChange={(e) => setEmail(e.target.value || '')}/>
                <TextField label='Pesel' value={personalId} onChange={(e) => setPersonalId(e.target.value || '')}/>
                <TextField label='Rodzice' value={parents} onChange={(e) => setParents(e.target.value || '')}/>
                <TextField label='Adres' value={address} onChange={(e) => setAddress(e.target.value || '')}/>
                <Toggle label="Zgoda Marketingowa" {...optionalProps} onText="Tak" offText="Nie" onChange={(e, checked) => setMarketing(checked)} />
            </form>
        </Panel>
    )
}

export default EditPerson;